// @ts-nocheck
import request from '../utils/request';
export function loadCurrentUser() {
    return request(false)
        .get("/api/v1/current-user/")
        .send();
}
